import React from 'react'
import './Login.css'
import loginimg from '../../assest/Log in & Contact Background Png.png'
import googleimg from '../../assest/Google Logo.png'
import rocketloginimg from '../../assest/ExamSify Contact Png.png'
import { Link, useNavigate } from 'react-router-dom'
import loginshapepng from '../../assest/log in, sign up & answer page png.png'


const Login = () => {
  const navigate = useNavigate()
  const handlesignup =()=>{
    navigate("/signup")
  }
  return (
    <>
      <div className='login-container'>
        <div className='login-left'>
          <img src={loginimg}/>
           <div className="overlay-img">
                <img src={rocketloginimg}/>
            </div>
        </div>
        <div className='login-right'>
          <h1>Examsify Log in</h1>
          <div className='login-shape'>
          <img src={loginshapepng}/>
          </div>
           <form >
              <div>
          <label className="login-email-label" htmlFor="email">Your Email</label>
          <input
            type="email"
            id="email"
            name="email"
            placeholder="Email address"
            
       
          />
        </div>
        <div>
        <label htmlFor="password">Password</label>
          <input
            type="password"
            id="password"
            name="password"
            placeholder="Enter password"
      
          />

        </div>
        <label className='forgot-password' >Forgot Password ?</label>
         <div className="login-submit-row">
          <button className="login-submit-btn" type="submit">
            <span>Sign in</span>
            <i className="fas fa-arrow-right"></i>
          </button>
        </div>
        <div className='adding-link'>
   <Link to="/signup">
  <p className='new'>
    New User?&nbsp;<span>Create Account</span>
  </p>
</Link>

        </div>
         <div className="login-divider">
          <hr />
          <span>SIGN IN WITH</span>
          <hr />
        </div>
        <button type="button" className="google-login-btn">
          <img
            src={googleimg}
            alt="Google logo"
            width="20"
            className='login-google-img'
            height="20"
          />
          <span>Google</span>
        </button>

        {/* <p className="already-login">Already Registered to ExamSify</p> */}
       
        
           </form>
        </div>
      </div>
    </>
  )
}

export default Login
